import classnames from 'classnames';
import * as React from 'react';
import { box, paddingInlineStart, paddingInlineEnd, paddingBlockStart, paddingBlockEnd, elevation, radius } from './box.css.js';

const defaultElement = 'div';
/**
 * Creates a micro-layout with some optional padding, elevation and radius.
 */
const Box = React.forwardRef(function Box({ as, className, padding = 'none', paddingInline = padding, paddingInlineStart: paddingInlineStart$1 = paddingInline, paddingInlineEnd: paddingInlineEnd$1 = paddingInline, paddingBlock = padding, paddingBlockStart: paddingBlockStart$1 = paddingBlock, paddingBlockEnd: paddingBlockEnd$1 = paddingBlock, elevation: elevation$1 = 'none', radius: radius$1 = 'none', ...rest }, ref) {
    const Element = as || defaultElement;
    return (React.createElement(Element, { className: classnames(box, paddingInlineStart[paddingInlineStart$1], paddingInlineEnd[paddingInlineEnd$1], paddingBlockStart[paddingBlockStart$1], paddingBlockEnd[paddingBlockEnd$1], elevation[elevation$1], radius[radius$1], className), ref: ref, ...rest }));
});

export { Box };
